import { Button, Grid, Typography } from '@mui/material';
import React from 'react';
import { contactUsPhone } from 'utils/consts';
import img from './imagens/Group.png';
import home from './imagens/iconHome.png';
import atendente from './imagens/iconAtendente.png';

function ErrorGeral() {
  const linkAtendimento = `https://api.whatsapp.com/send?phone=${contactUsPhone}&text=Fale%20j%C3%A1%20conosco%20e%20tire%20sua%20d%C3%BAvida%20sobre%20nosso%20sistema%20.`;

  return (
    <Grid
      container
      spacing={2}
      alignContent="center"
      alignItems="stretch"
      style={{
        display: 'flex',
        justifyContent: 'center',
        paddingBlock: '10rem',
      }}
    >
      <Grid item>
        <Typography align="center">
          <img src={img} />
        </Typography>

        <Typography
          style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            textAlign: 'center',
            marginBlock: '1rem',
          }}
        >
          Atenção!
        </Typography>

        <Typography
          style={{
            fontSize: '1.5rem',
            fontWeight: '500',
            textAlign: 'center',
            marginBlock: '1rem',
          }}
        >
          Algo deu errado, se o erro persistir entre em contato com o suporte:
        </Typography>

        <Typography
          style={{ margin: '1rem', display: 'flex', justifyContent: 'center' }}
        >
          <Button
            size="large"
            variant="contained"
            style={{
              margin: '1rem',
              backgroundColor: '#057C43',
              color: 'white',
            }}
            href={linkAtendimento}
          >
            <img src={atendente} style={{ marginInline: '10px' }} />
            Atendimento ao Cliente
          </Button>

          <Button
            color="primary"
            size="large"
            variant="contained"
            href="https://app.crevettic.com/"
            style={{ margin: '1rem' }}
          >
            <img src={home} style={{ marginInline: '10px' }} />
            Volte para tela inicial
          </Button>
        </Typography>
      </Grid>
    </Grid>
  );
}

export default ErrorGeral;
